import styled, { css } from "styled-components";

export const SubmitButton = styled.button`
  ${({
    theme,
    size,
    height,
    disabled,
    background,
    hover,
    transform,
    font,
    weight,
    padding,
  }) => css`
    top: 40px;
    padding: ${padding ? padding : "12px 24px"};
    white-space: nowrap;
    font-size: ${font ? font : "15px"};
    font-weight: ${weight ? weight : "600"};
    background: ${background ? background : "#66d7d1"};
    color: #fff;
    cursor: ${disabled ? "not-allowed" : "pointer"};
    margin-bottom: 0.4rem;
    border: 1px solid ${background ? background : "#66d7d1"};
    text-transform: ${transform ? transform : "uppercase"};
    &: hover {
      background: ${hover ? hover : "#0096bc"};
    }
    @media only screen and (max-width: 425px) {
      width: 100%;
      font-size: 11px;
      font-weight: 600;
    }
    @media only screen and (min-width: 500px) and (max-width: 768px) {
      padding: ${padding ? "0.8em 0.5em" : "12px 24px"};
      font-size: 15px;
    }
    @media only screen and (min-width: 1024px) and (max-width: 1440px) {
      padding: ${padding ? "0.8em 3.5em" : "12px 24px"};
    }
  `}
`;
